export const classes = {
  viewer: 'flex grow min-w-0',
};
